import React from "react"
import { API } from "../../api"
import CheckoutFooter from "./../CheckoutFooter"
// import { ROUTES } from "../../common/utils"
// import { Link } from "react-router-dom"
import "./ProductDetails.css"
import NotFound from "../../common/NotFound"
import Loader from "../../common/Loader"
import ProductImageGallery from "./ProductImageGallery"

class ProductDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      productData: {},
      images: [],
      fetching: true,
      notFound: false
    }
    this.getProductDetails.bind(this)
  }

  componentDidMount() {
    this.getProductDetails()
  }

  goBack = () => {
    this.props.history.goBack()
  }

  async getProductDetails() {
    const { match } = this.props
    let type = match.params.type === "custom" ? "custom_product" : "product"
    try {
      const response = await API.get(
        `/checkout/${type}/${match.params.product_id}`
      )
      this.setState(state => ({
        ...state,
        productData: response.data,
        images: response.data.images
      }))
    } catch (error) {
      console.log("Error: ", error.response)
      if (
        error &&
        error.response.data.code === "order/checkout/order-product-not-found"
      ) {
        this.setState({ notFound: true })
      }
    } finally {
      this.setState({ fetching: false })
    }
  }

  render() {
    const { productData, images, fetching, notFound } = this.state
    return (
      <div className="ProductDetails">
        {(!fetching &&
          ((!notFound && (
            <>
              <div className="header">
                <h1>
                  {productData.businessname &&
                    productData.businessname.toUpperCase()}
                </h1>
              </div>
              <div className={`checkout-content content-section cart`}>
                <ProductImageGallery images={images} />
                <div className="details">
                  <p className="prodName">{productData.name}</p>
                  {productData.variant_value_01 &&
                    productData.variant_value_01 !== "default_option" &&
                    productData.variant_value_02 &&
                    productData.variant_value_02 !== "default_option" && (
                      <p className="variantName">
                        {`${productData.variant_value_01 &&
                          productData.variant_value_01}${
                          productData.variant_value_01 &&
                          productData.variant_value_01 !== "default_option"
                            ? `, ${productData.variant_value_02}`
                            : ""
                        }`}
                      </p>
                    )}
                  <p className="price">{`${productData.currency} ${parseFloat(
                    productData.price
                  ).toLocaleString("en", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                  })}`}</p>
                  {productData.description && (
                    <>
                      <p className="detailHeader">Product Details</p>
                      <p className="description">{productData.description}</p>
                    </>
                  )}
                  <button className="black" onClick={this.goBack} type="button">
                    Back to checkout
                  </button>
                </div>
              </div>
              <CheckoutFooter businessName={productData.businessname} />
            </>
          )) || <NotFound />)) || <Loader />}
      </div>
    )
  }
}

export default ProductDetails
